import styled from "styled-components";

export const Container = styled.div`
  margin: 100px;
  overflow: hidden;
  @media (max-width: 786px) {
    margin:40px;
  }
  @media (max-width: 576px) {
    margin:25px;
  }


`;
export const Heading=styled.h2`
text-align:center;
font-weight:bold;

`;
export const ImageContainer = styled.div`
  width: 100%;
  display:flex;
  align-items:stretch;
  margin:0px !important;
`;
export const LogoContainer = styled.div`
  width: 100%;
  display:flex;
  background-color:#fff9ed;
  height:320px;
  `;
  export const LogoContainer1 = styled.div`
  width: 100%;
  display:flex;
  background-color:#fefcf7;
  height:320px;

`;

export const Image = styled.img`
width:170px;
height:auto;
margin:auto;
`;

export const TEXT=styled.p`
line-height:35px;
text-align:center;
margin-top:25px;
`;



export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 350px;
`;

export const CardContainer = styled.div`
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 5px 8px 6px #00000029;
  border-radius: 5px;
  opacity: 1;

  min-height: 334px;
  margin-bottom: 100px;
  margin-top: 100px;
  position: relative;
  top: -50%;
`;



export const ContactDetails = styled.div`
  display: flex;
  flex-direction: row;
  padding: 25px;
  justify-content: space-around;
`;

export const TitleContainer = styled.div`

`;

export const Name = styled.p`
  font-size:20px !important;
  width:100%;
  @media (max-width: 786px) {
    font-size:14px !important;
  }
  `;
  export const ContactInfo = styled.p`
  font-size:20px !important;
  font-weight:bold;
  width:100%;
  margin-top:-20px;
  @media(max-width: 786px) {
    margin-top:-15px;
    font-size:14px !important;
  }

`;

export const NumberContainer = styled.div``;

export const InnerBackgroundContainer = styled.div`
  background-color: #ffbe4d;
  height: 400px;
  margin-top: 300px;

`;

export const WriteUSCard = styled.div`
  display: flex;
  flex-direction: row;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 5px 8px 6px #00000029;
  border-radius: 5px;
  opacity: 1;

  height: auto;
  margin-bottom: 150px;
  margin-top: 50px;
  position: relative;
  top: -230px;

  .ant-input {
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    width: 100% !important;
    :hover {
      border-color: none !important;
    }
    :focus {
      border-color: none !important;
    }
  }
`;

export const InnerLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 47px;
  border-right: 1px solid #00000029;
  margin-top: 15px;
  @media (max-width: 786px) {
    border-right: none;
  }
  @media (max-width: 786px) {
    padding-left: auto;
  }
`;

export const Heading2 = styled.h1`
  font-size: 60px;
  font-family: Poppins-Bold;
  padding: 40px 0px 0px 0px;
`;

export const Line = styled.div`
  border-top: 5px solid #f08700;
  width: 33.33%;
`;
export const BottomContanier = styled.div``;

export const Label = styled.p`
  font-size: 26px;
  color: #1d1d1d;
  font-family: Poppins-Regular;
  padding-top: 28px;
  margin-bottom: unset;
`;

export const Text = styled.p`
  padding-top: 80px;
  font-size: 18px;
  font-family: Poppins-Light;
`;

export const InnerRightContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: end;
`;

export const Button = styled.button`
  width: 100%;
  height: 103px;
  bottom: 0px;
  background-color: #f08700;
  color: #ffffff;
  font-size: 20px;
  font-family: Poppins-Light;
  border: none;
  cursor: pointer;
  @media (max-width: 786px) {
    margin-bottom: 25px;
    height: 40px;
  }
`;
